import React from "react";

import { StyledInput } from "./simpleLabeledText.style";

const SimpleLabeledText = ({
  register,
  value,
  name,
  required,
  label,
  maxCharacters,
  error,
  readOnly,
  ...rest
}) => {
  const withRegister = () => {
    if (!register) return { value: value };

    const { onChange, onBlur, ref } = register(name, {
      required: {
        value: required,
        message: "This field is required",
      },
      value: value,
      maxLength: {
        value: maxCharacters,
        message: `Maximum length is ${maxCharacters} characters`,
      },
    });

    return {
      onChange,
      name,
      onBlur,
      ref,
    };
  };

  return (
    <StyledInput $error={error ? 1 : 0} $maxcharacters={maxCharacters}>
      <div>
        <input
          type="text"
          {...withRegister()}
          {...rest}
          readOnly={readOnly}
          placeholder=" "
        />
        <label>{label}</label>
      </div>
      <span className="error">{error?.message || ""}</span>
    </StyledInput>
  );
};

export default SimpleLabeledText;

// id: 6247,
// title: "<p>What's your name?</p>",
// fieldType: "input",
// required: false,
// options: null,
// placeholder: "Peter",
// groupId: "",
// maxCharacters: 25,
